'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeTimeOnPageTrigger = undefined;

var _getTimeOnPageTriggerTimeoutId = require('../selectors/getTimeOnPageTriggerTimeoutId');

var _removeTimeOnPageTriggerAction = require('./removeTimeOnPageTriggerAction');

var removeTimeOnPageTrigger = exports.removeTimeOnPageTrigger = function removeTimeOnPageTrigger() {
  return function (dispatch, getState) {
    var timeoutId = (0, _getTimeOnPageTriggerTimeoutId.getTimeOnPageTriggerTimeoutId)(getState());

    clearTimeout(timeoutId);

    dispatch((0, _removeTimeOnPageTriggerAction.removeTimeOnPageTriggerAction)());
  };
};